class Attendance {
    constructor(data = {}) {
      this.id = data.id || data._id || null;
      this._id = data._id || data.id || null;
      this.employeeId = data.employeeId || null;
      this.date = data.date || new Date().toISOString().split('T')[0];
      this.checkIn = data.checkIn || '';
      this.checkOut = data.checkOut || '';
      this.workHours = data.workHours || data.workingHours || 0;
      this.status = data.status || 'Present';
      this.lateBy = data.lateBy || 0;
      this.earlyLeaveBy = data.earlyLeaveBy || 0;
      this.overtime = data.overtime || 0;
      this.location = data.location || '';
      this.remarks = data.remarks || '';
      this.approvedBy = data.approvedBy || null;
      this.createdAt = data.createdAt || new Date().toISOString();
    }
  
    getStatusColor() {
      const colors = { 'Present': '#10b981', 'Absent': '#ef4444', 'Half Day': '#f59e0b', 'Leave': '#3b82f6', 'Holiday': '#8b5cf6' };
      return colors[this.status] || '#6b7280';
    }
  
    calculateWorkHours() {
      if (!this.checkIn || !this.checkOut) return 0;
      const start = new Date(`2000-01-01 ${this.checkIn}`);
      const end = new Date(`2000-01-01 ${this.checkOut}`);
      return Math.round((end - start) / (1000 * 60 * 60) * 10) / 10;
    }
  
    isLate(standardTime = '09:00') {
      if (!this.checkIn) return false;
      return this.checkIn > standardTime;
    }
  
    validate() {
      const errors = [];
      if (!this.employeeId) errors.push('Employee is required');
      if (!this.date) errors.push('Date is required');
      if (this.status === 'Present' && !this.checkIn) errors.push('Check-in time required for present status');
      return { isValid: errors.length === 0, errors };
    }
  
    toJSON() { return { ...this }; }
    static fromJSON(json) { return new Attendance(json); }
  }
  export default Attendance;